export class CaseAssignmentEditModel{
    
    assignedTo:string;    
    assignmentDate:Date;
}